import { INSURANCE_TYPES_NAMES } from 'constants/insurance-types-names';
import { LIFE_MARKET_SCAN_WAITING_TIME } from 'constants/marketScan';
import { TASK_TYPES } from 'constants/notification';
import {
  MARKET_SCAN_PURCHASE_ROUTE,
  MARKET_SCAN_RESULTS_ROUTE,
  MARKET_SCAN_STATUS_ROUTE,
} from 'constants/routes';
import moment from 'moment';
import { INotification } from 'types';
import { getMarketScanLifeResultsRoute } from './route';
import history from 'helpers/history';

export const showNotificationByRoute = () => {
  const currentPath = window.location.pathname;

  const routesToCheck = [
    MARKET_SCAN_PURCHASE_ROUTE,
    MARKET_SCAN_RESULTS_ROUTE,
    MARKET_SCAN_STATUS_ROUTE,
  ];

  return !routesToCheck.some((route) => currentPath.includes(route));
};

export const updatePendingLifePolicyScanToReady = (notification: INotification) => {
  if (notification.policyType === INSURANCE_TYPES_NAMES.LIFE && notification.notificationType === TASK_TYPES.POLICY_SCAN_PENDING) {
    notification.notificationType = TASK_TYPES.POLICY_SCAN_READY
  }
  return notification
}

export const redirectToLifeMarketScanResults = (item: { id: string, sk: string, createdAt: string }) => {
  const diff = moment().diff(moment(item.createdAt), "milliseconds")
  if (diff < LIFE_MARKET_SCAN_WAITING_TIME) {
    const waitingTime = (LIFE_MARKET_SCAN_WAITING_TIME - diff)
    history.push(
      getMarketScanLifeResultsRoute(
        item.id,
        item.sk,
        waitingTime
      ),
    );
  } else {
    history.push(
      getMarketScanLifeResultsRoute(
        item.id,
        item.sk
      ),
    );
  }
}